'use strict';
// B.2.3.5 String.prototype.bold()
require('./_string-html')('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});



//////////////////
// WEBPACK FOOTER
// /Users/m802941/.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/es6.string.bold.js
// module id = 257
// module chunks = 9